<div class="flex h-full text-base-content scroll-smooth font-poppins bg-white">
  <!-- ============================= SIDEBAR ============================= -->
  <aside class="w-72 p-6 overflow-y-auto h-full border-r border-gray-200">
    <nav #sideNav class="space-y-1 scroll-smooth">
      <h1 class="text-2xl font-bold mb-1 text-[#1594fd]">{{ heading }}</h1>
      @if (subheading) {
        <p class="text-xs text-gray-500 mb-6">{{ subheading }}</p>
      }

      <!-- Flat groups — sections always in the DOM, scrolled to via the href -->
      @for (group of flatGroups; track group.title) {
        <p class="px-3 pt-4 pb-1 text-[11px] font-bold uppercase tracking-wider text-gray-400">
          {{ group.title }}
        </p>
        @for (item of group.items; track item.id) {
          <a
            [href]="basePath + '#' + item.id"
            [attr.data-nav-id]="item.id"
            [class]="linkClass(item.id)"
            [attr.aria-current]="item.id === activeId() ? 'true' : null"
            (click)="selectFlat(item.id)"
          >
            {{ item.label }}
          </a>
        }
      }

      <!-- Accordion panels — User Guide / User Architecture -->
      @if (panels.length) {
        @if (panelsHeading) {
          <p class="px-3 pt-4 pb-1 text-[11px] font-bold uppercase tracking-wider text-gray-400">
            {{ panelsHeading }}
          </p>
        }
        @for (panel of panels; track panel.id) {
          <button
            type="button"
            (click)="togglePanel(panel.id)"
            [attr.aria-expanded]="isExpanded(panel.id)"
            class="w-full flex items-center justify-between gap-2 mt-1 pl-3 pr-2 py-2 rounded-lg text-sm font-semibold text-black hover:bg-gray-100 transition-colors"
          >
            <span>{{ panel.label }}</span>
            <svg
              class="w-4 h-4 flex-shrink-0 text-gray-400 transition-transform duration-200"
              [class.rotate-90]="isExpanded(panel.id)"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round"
            >
              <path d="M9 18l6-6-6-6" />
            </svg>
          </button>
          @if (isExpanded(panel.id)) {
            <div class="mb-1 ml-3 border-l border-gray-200 pl-2 space-y-1">
              @for (group of panel.groups; track group.title) {
                <p class="px-3 pt-3 pb-1 text-[10px] font-bold uppercase tracking-wider text-gray-400">
                  {{ group.title }}
                </p>
                @for (item of group.items; track item.id) {
                  <a
                    [href]="basePath + '#' + item.id"
                    [attr.data-nav-id]="item.id"
                    [class]="linkClass(item.id)"
                    [attr.aria-current]="item.id === activeId() ? 'true' : null"
                    (click)="selectLeaf(panel.id, item.id, $event)"
                  >
                    {{ item.label }}
                  </a>
                }
              }
            </div>
          }
        }
      }
    </nav>
  </aside>

  <!-- ============================== MAIN =============================== -->
  <main #scrollRoot class="flex-1 overflow-y-auto scroll-smooth h-full [scrollbar-gutter:stable]">
    <div class="container flex flex-col max-w-4xl mx-auto px-8 space-y-16 pb-32 pt-8">
      <ng-content></ng-content>
    </div>
  </main>
</div>
